import React, { useState } from 'react';
import { Modal, ModalOpen, ModalClose, ModalUpdate } from '../Modal';
import { Container, Row, Col } from 'reactstrap';
import Butt from './Butt';
import { T } from '../traks';
import { AUAContainer } from '../AUA';
import API from '../API';
import store from '../store';
import ActionLink from './ActionLink';
import { site_name } from '../Site';

const get_required_actions = (me) => {
	return {
		provide_email: me && me.Epoch >= 2 && !me.LocalEmail,
		accept_terms: me && !me.AcceptedAllTerms,
	};
};

const should_open = (me) => {
	const required_actions = get_required_actions(me);
	for (const k in required_actions) if (required_actions[k]) return true;
	return false;
}

const open_if_required = (me) => {
	if (should_open(me)) ModalOpen("BeforeWeLetYouInModal");
};

let BeforeWeLetYouInEvenInnerer = (props) => {
	const required_actions = get_required_actions(props.aua.me);

	const [ email, set_email ] = useState("");
	const [ err, set_err ] = useState(false);
	const [ did_focus_once, set_did_focus_once ] = useState(false);
	const [ have_sacrificed_my_first_born, set_have_sacrificed_my_first_born ] = useState(false);

	const close = () => {
		ModalClose();
	};

	const change = (e) => {
		set_email(e.target.value);
	};

	const focus_once = (ref) => {
		if (ref && !did_focus_once) {
			ref.focus();
			set_did_focus_once(true);
		}
	};

	const validate_and_post = (e) => {
		e.preventDefault();
		if (required_actions.provide_email && email.trim().length === 0) {
			set_err("email_invalid");
		} else {
			props.aua.request.provide_email_and_accept_all_terms(email, (err) => {
				if (err) {
					set_err(err.code);
				} else {
					close();
				}
			});
		}
	};

	const login_with_email = () => {
		API.post("/a/signout", {}, () => {
			store.dispatch_me(null);
			ModalUpdate("SignupLoginModal", {kind: "login", initial_email: email});
		});
	}

	const logout = () => {
		API.post("/a/signout", {}, () => {
			window.location.reload();
		});
	};

	let show_login_with_email = false;
	let errorow;
	switch (err) {
	case "email_conflict":
		errorow = <T>The email address is being used by another account</T>;
		show_login_with_email = true;
		break;
	case "email_invalid":
		errorow = <T>You must enter a valid email address</T>;
		break;
	default:
	}

	if (errorow) errorow = <div className="errors pb-3">{errorow}</div>;

	let can_submit = true;
	let submit_button_text = null;
	if (required_actions.provide_email) {
		submit_button_text = <T>Submit email</T>
	} else {
		submit_button_text = <T>Continue</T>
	}

	let require_email_element = null;
	if (required_actions.provide_email) {
		require_email_element = (
			<React.Fragment>
				<Row className="pb-4">
					<Col className="pb-2">
						<div className="pb-4">
							<T>
							Enter your email to finish registration, so we
							can inform you about your games and other features.
							You can always unsubscribe.
							</T>
						</div>
						<input
							className="form-control p-3 ad_signuplogin_input"
							ref={focus_once}
							name="email"
							type="email"
							value={email}
							onChange={change}
							placeholder="Email"
						/>
					</Col>
				</Row>
				{errorow}
			</React.Fragment>
		);
		can_submit &= (email.trim().length > 0);
	}

	let accept_terms_element = null;
	if (required_actions.accept_terms) {
		accept_terms_element = (
			<div>
				<label htmlFor="check_this_box" className="pb-3">
					<div className="d-inline-block align-text-bottom">
						<input id="check_this_box" type="checkbox" checked={have_sacrificed_my_first_born} onChange={() => set_have_sacrificed_my_first_born(!have_sacrificed_my_first_born)}/>
					</div>
					<span className="pl-2"><T>I've read and accepted both the {site_name} <a target="_blank" className="ad_blue_link" href="/privacy">Privacy Policy</a> and <a target="_blank" className="ad_blue_link" href="/termsofuse">Terms of Use</a>.</T></span>
				</label>
			</div>
		);
		can_submit &= have_sacrificed_my_first_born;
	}

	return (
		<div className="ad_signuplogin_dark"><Container>
		<Row className="p-0">
			<Col className="ad_signuplogin_dark ad_require_email_modal">
				<div className="mx-sm-5 mt-5">
					<form onSubmit={validate_and_post}>
					{require_email_element}
					{accept_terms_element}
					<Row>
						<Col>
							<Butt className="xyzzy_button ad_rbtn w-100 ad_signuplogin_btn px-5 py-3 mb-3" type="submit" disabled={!can_submit}>{submit_button_text}</Butt>
							{show_login_with_email && <Butt className="xyzzy_button ad_rbtn w-100 ad_signuplogin_btn px-5 py-3 mb-3" onClick={login_with_email}><T>Login with email</T></Butt>}
						</Col>
					</Row>
					<Row>
						<Col className="pb-4">
							<ActionLink className="ad_signuplogin_text" on_click={logout}><T>Logout</T></ActionLink>
						</Col>
					</Row>
					</form>
				</div>
			</Col>
		</Row>
		</Container></div>
	);
};

const BeforeWeLetYouInInner = (props) => <AUAContainer><BeforeWeLetYouInEvenInnerer {...props}/></AUAContainer>;

class BeforeWeLetYouInModal extends Modal {
	allow_close_via_ui() {
		return false;
	}

	mrender() {
		return <BeforeWeLetYouInInner/>
	}

	get_name() {
		return "BeforeWeLetYouInModal";
	}

	get_fullscreen_bg_class() {
		return "ad_signuplogin_dark";
	}

	get_bootstrap_modal_class() {
		return "ad_signuplogin_modal_sm";
	}
}

const BeforeWeLetYouIn = {
	open_if_required: open_if_required,
	Modal: BeforeWeLetYouInModal,
}

export default BeforeWeLetYouIn;



// WEBPACK FOOTER //
// ./src/c/BeforeWeLetYouIn.js